import React, { useState, useContext } from "react";
import { useParams } from "react-router";

import { useForm, Controller } from "react-hook-form";

import { P } from "../../atoms/Texts";
import {
  CustomSelectDropdown,
  DarkFormField,
  DarkTextArea,
  MultipleFileInput,
} from "../../atoms/Inputs";
import { PrimaryButton } from "../../atoms/Buttons";
import ModalHolder from "../../molecules/ModalHolder";

import { selectStyle } from "../../../shared/fixtures/select_style";
import { toastWarning } from "../../../shared/helpers";

const EditInitiativeModal = ({ closeModal, initiative }) => {
  const [files, setFiles] = React.useState([]);

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
  } = useForm();

  const handleEditInitiative = () => {
    toastWarning("Can not perform this action on Demo mode");
    closeModal();
  };

  return (
    <ModalHolder closeModal={closeModal} header="Edit Initiative">
      <form onSubmit={handleEditInitiative} className=" py-6 grid grid-cols-1 gap-4">
        <div key={`name`} className="col-span-2">
          <div className="flex items-center justify-between">
            <DarkFormField
              containerClass="w-full"
              type="text"
              id={`name`}
              name={`name`}
              disabled={true}
              placeholder="Input initiative name"
              label="Name of Initiative"
              defaultValue={initiative?.name}
              {...register("name")}
            />
          </div>
        </div>

        <div className="mb-4">
          <label htmlFor={`service`}>
            <P fontSize="14px" fontFamily="semi" color="#47495C" className="mb-2">
              Service
              <span
                className=""
                style={{
                  color: "#E62250",
                }}
              >
                *
              </span>
            </P>
          </label>

          <Controller
            control={control}
            id="service"
            name="service"
            defaultValue={initiative?.service?.name}
            render={({ field }) => (
              <CustomSelectDropdown
                {...field}
                styles={selectStyle}
                autoComplete="true"
                value={initiative?.service?.name}
                isDisabled={true}
                placeholder={initiative?.service?.name}
                className="w-full"
              />
            )}
          />
        </div>

        <div key={`description`} className=" col-span-2">
          <div className="flex items-center justify-between">
            <DarkTextArea
              rows={3}
              containerClass="w-full"
              id={`description`}
              name={`description`}
              disabled={true}
              placeholder="Type description here"
              label="Description"
              defaultValue={initiative?.description}
              {...register("description")}
            />
          </div>
        </div>

        <div key={`images`} className=" col-span-2">
          <label htmlFor={`images`}>
            <P
              fontSize="14px"
              fontFamily="semi"
              color="#47495C"
              className="mb-2"
              fontWeight="bold"
            >
              Update Images
              <span
                className=""
                style={{
                  fontWeight: "normal",
                }}
              >
                (optional)
              </span>
            </P>
          </label>
          <MultipleFileInput
            rows={3}
            label={
              <div>
                <P className="font-normal" color="#442ED0">
                  <span className="font-semibold text-sm">Click to upload</span> {""}
                  <span className="text-gray-500  text-sm">or drag and drop</span>
                </P>

                <p className="text-xs ">SVG, PNG, JPG (max. 1MB)</p>
              </div>
            }
            id={`images`}
            name={`images`}
            accept=".jpeg,.jpg,.png"
            className="w-full"
            files={files}
            setFiles={setFiles}
            {...register("images")}
          />{" "}
        </div>

        <div className="w-full bg-red-400">
          <PrimaryButton type="submit" className="w-full">
            Edit intiative
          </PrimaryButton>
        </div>
      </form>
    </ModalHolder>
  );
};

export default EditInitiativeModal;
